import { render, staticRenderFns } from "./SinglePostcard.vue?vue&type=template&id=63e25feb&"
import script from "./SinglePostcard.vue?vue&type=script&lang=js&"
export * from "./SinglePostcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports